function closeAll() {
    $('.accordion-content').addClass("accordion-item-hidden");
}
module.exports = {
    initialize: function () {
        closeAll();
    },
    bindClickHandlers: function() {
        $(".accordion-option").click(function () {
            closeAll()
            $(this).next().removeClass("accordion-item-hidden");
        });

        $(".accordion-option-toggle").click(function () {
            let element = $(this).next();
            let isClosed = element.hasClass("accordion-item-hidden");
            closeAll();

            if (isClosed) {
                element.removeClass("accordion-item-hidden");
            }
        });
    }
};
